<template>
  <div>
    <h1 class="mb-8 mt-5 px-4 text-3xl font-bold">
      {{ header }}
    </h1>
    <flash-messages />
    <form @submit.prevent="addClient">
      <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden mb-8">
        <div class="flex items-center px-8 py-4 bg-gray-50 border-b border-gray-100">
          <button class="text-600 hover:underline" tabindex="-1" type="button" @click="returnBack">Вернуться</button>
          <loading-button v-if="client" :loading="addClientForm.processing" class="btn-danger ml-auto" type="button" @click="cancel">Отменить поездку</loading-button>
          <loading-button v-if="!client" :loading="addClientForm.processing" class="btn-indigo ml-auto" type="submit">Забронировать</loading-button>
        </div>
        <div v-if="deposit_enabled && client && client.pivot.paid == 0
                  && ((client.deposit * client.pivot.seats) < ((deposit_amount-50) * client.pivot.seats))"
             class="flex items-center px-8 py-4 bg-yellow-100 border-b border-gray-100">
          <div>Поездка не обеспечена!</div>
          <loading-button v-if="client" :loading="addClientForm.processing" class="btn-indigo ml-auto" type="button" @click="addDeposit">Внести депозит</loading-button>
        </div>
        <div v-if="deposit_enabled && client && client.pivot.paid == 0
                  && ((client.deposit * client.pivot.seats) < ((deposit_amount-50) * client.pivot.seats))"
             class="flex items-center px-8 py-4 bg-yellow-100 border-b border-gray-100">
          <div>Внимание! Депозит нельзя будет использовать для оплаты этой поездки. Депозит вносится минимум на две недели.</div>
        </div>
        <div class="flex items-center py-2 px-4">
          <div>Маршрут</div>
          <div class="ml-auto">{{ trip.route.name}}</div>
        </div>
        <div class="flex items-center py-2 px-4">
          <div>Дата</div>
          <div class="ml-auto">{{ trip.trip_date }}</div>
        </div>
        <div class="flex items-center py-2 px-4">
          <div>Номер рейса</div>
          <div class="ml-auto">{{ trip.id}}</div>
        </div>
        <div class="flex items-center py-2 px-4">
          <div>Статус поездки</div>
          <div class="ml-auto">{{ trip.status_name}}</div>
        </div>
        <div class="flex items-center py-2 px-4">
          <div>Авто</div>
          <div class="ml-auto">{{ trip.car.mark }} {{ trip.car.model }} {{ trip.car.color }} {{ trip.car.grn }}</div>
        </div>
        <div class="flex items-center py-2 px-4">
          <div>Водитель</div>
          <div class="ml-auto">{{ trip.driver_info }}</div>
        </div>
        <div class="flex items-center py-2 px-4">
          <div>Стоимость</div>
          <div v-if="!client" class="ml-auto ">{{ trip.price }} руб.</div>
          <div v-if="client" class="ml-auto">
            <span v-if="client.pivot.price === client.pivot.final_price">{{ client.pivot.price }} руб.</span>
            <span v-if="client.pivot.price !== client.pivot.final_price">
              <span style="text-decoration: line-through; color: rgb(128,128,128)">{{ client.pivot.price }}</span>
              <span style="font-weight: bold">{{ client.pivot.final_price }} руб.</span>
            </span>
          </div>
        </div>
        <div v-if="client && client.pivot.point_time != 0" class="flex items-center py-2 px-4">
          <div>Время сбора на точке:</div>
          <div class="ml-auto font-bold" >{{ client.pivot.point_time }}</div>
        </div>
        <div v-if="trip.comment" class="flex items-center py-2 px-4">
          <div class="mx-auto">Информация для пассажиров</div>
        </div>
        <div v-if="trip.comment" class="flex items-center py-2 px-4">
          <div class="mx-auto italic">{{ trip.comment }}</div>
        </div>
        <div class="flex flex-wrap flex-lg-nowrap -mb-8 -mr-6 p-4">
          <select-input v-model="addClientForm.point_id" :error="addClientForm.errors.point_id" :disabled="!!client" class="pb-8 pr-6" label="Выберите точку сбора">
            <option :value="null" />
            <option v-for="point in points" :key="point.id" :value="point.id" :selected="point.pivot.point_id === point.id"> {{ point.name }} </option>
          </select-input>
          <select-input v-model="addClientForm.seats" :error="addClientForm.errors.seats" :disabled="!!client" class="pb-8 pr-6" label="Количество мест">
            <option value="1" :selected="addClientForm.seats === 1">1</option>
            <option value="2" :selected="addClientForm.seats === 2">2</option>
            <option value="3" :selected="addClientForm.seats === 3">3</option>
            <option value="4" :selected="addClientForm.seats === 4">4</option>
            <option value="5" :selected="addClientForm.seats === 5">5</option>
            <option value="6" :selected="addClientForm.seats === 6">6</option>
          </select-input>
          <textarea-input v-model="addClientForm.comment" :error="addClientForm.errors.comment" :disabled="!!client" class="pb-8 pr-6 w-full" label="Комментарии" placeholder="Ваши комментарии и пожелания к поездке" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button class="text-600 hover:underline" tabindex="-1" type="button" @click="returnBack">Вернуться</button>
          <loading-button v-if="client" :loading="addClientForm.processing" class="btn-danger ml-auto" type="button" @click="cancel">Отменить поездку</loading-button>
          <loading-button v-if="!client" :loading="addClientForm.processing" class="btn-indigo ml-auto" type="submit">Забронировать</loading-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import FlashMessages from '@/Shared/FlashMessages'

export default {
  components: {
    TextareaInput,
    FlashMessages,
    LoadingButton,
    SelectInput,
  },
  props: {
    trip: Object,
    points: Array,
    client: Object,
    error: String,
    deposit_enabled: Boolean,
    deposit_amount: Number,
  },
  data() {
    return {
      addClientForm: this.$inertia.form({
        authData: authData ? authData : Telegram.WebApp.initData,
        point_id: this.client ? this.client.pivot.point_id : '',
        comment: this.client ? this.client.pivot.comment : '',
        address: this.client ? this.client.pivot.address : null,
        seats: this.client ? this.client.pivot.seats : 1,
      }),
      header: this.client ? 'Моя поездка' : 'Забронировать поездку'
    }
  },
  methods: {
    addClient() {
      this.addClientForm.post(`/webapp/client/trip/join/${this.trip.id}`, {
        authData: authData ? authData : Telegram.WebApp.initData,
      })
    },

    addDeposit() {
      this.addClientForm.post(`/webapp/client/addDeposit`, {
        authData: authData ? authData : Telegram.WebApp.initData,
      })
    },

    cancel() {
      this.addClientForm.post(`/webapp/client/trip/cancel/${this.trip.id}`, {
        authData: authData ? authData : Telegram.WebApp.initData,
      })
    },

    returnBack() {
      this.$inertia.visit('/webapp/init', {
        method: 'post',
        data: {
          authData: authData ? authData : Telegram.WebApp.initData,
        },
      })
    },
  },
}
</script>
